import { render } from "./TermsPolicySchemajson.vue?vue&type=template&id=5ef6806e"
import script from "./TermsPolicySchemajson.vue?vue&type=script&lang=js"
export * from "./TermsPolicySchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__